import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/logout.css";

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    logout().then(() => navigate("/login")).catch(() => navigate("/"));
  }, [logout, navigate]);

  return (
    <div className="logout">
      <div className="logout__card">
        <p className="logout__text">Signing you out...</p>
        <div className="logout__spinner" />
      </div>
    </div>
  );
};

export default Logout;
